// ─────────────────────────────────────────────────────────────────────────────
// Friendly display labels + option-mapping formatting for the Manual Trading page.
// Maps the raw Manual Strategy config values to human-readable UI text.
// ─────────────────────────────────────────────────────────────────────────────

export function friendlyTradeIn(v) {
  const t = String(v || '').toUpperCase();
  if (t === 'OPTION' || t === 'OPTIONS') return 'Option';
  if (t === 'UNDERLYING') return 'Underlying';
  return v || '—';
}

export function friendlySegment(v) {
  const t = String(v || '').toUpperCase();
  const map = { STOCK: 'Stock', INDEX: 'Index', FNO: 'F&O', COMMODITY: 'Commodity', ETF: 'ETF' };
  return map[t] || v || '—';
}

export function friendlyProductType(v) {
  const t = String(v || '').toUpperCase();
  const map = { INTRADAY: 'Intraday', MARGIN: 'Margin', CNC: 'CNC', MTF: 'MTF', DELIVERY: 'Delivery' };
  return map[t] || v || '—';
}

export function friendlyQtyMode(v) {
  const t = String(v || '').toUpperCase();
  if (t === 'FIXED_QTY') return 'Fixed Qty';
  if (t === 'BY_MARGIN') return 'Margin';
  return v || '—';
}

export function expiryLabel(v) {
  const t = String(v || '').toUpperCase();
  const map = {
    CURRENT_WEEK: 'Current Week',
    NEXT_WEEK: 'Next Week',
    CURRENT_MONTH: 'Current Month',
    NEXT_MONTH: 'Next Month',
  };
  return map[t] || v || '—';
}

// One leg → "BUY CE | Current Month | ATM"
export function formatLeg(leg) {
  if (!leg) return '—';
  const strike = leg.strike_type || (leg.strike_selection_mode === 'closest_premium' ? 'Premium' : 'ATM');
  return `${leg.action} ${leg.option_type} | ${expiryLabel(leg.expiry_type)} | ${strike}`;
}

// exec → "Bullish CE ATM / Bearish PE ATM" (first leg of each side)
export function optionMappingSummary(execution) {
  const b = execution?.bullish_signal_legs?.[0];
  const s = execution?.bearish_signal_legs?.[0];
  if (!b && !s) return null;
  const part = (lbl, leg) =>
    leg ? `${lbl} ${leg.option_type} ${leg.strike_type || 'ATM'}` : null;
  return [part('Bullish', b), part('Bearish', s)].filter(Boolean).join(' / ');
}

// Manual UI display label for an order type. Temporary simplification: the protected-MARKET flow and
// effective LIMIT both surface as "Limit" (display-only; the stored/sent value is unchanged).
export function manualOrderTypeLabel(v) {
  const t = String(v ?? '').trim().toUpperCase();
  if (t === 'MARKET' || t === 'LIMIT') return 'Limit';
  if (t === 'SL-M' || t === 'SLM') return 'SL-M';
  if (t === 'SL-L' || t === 'SL') return 'SL-L';
  return v || 'Limit';
}
